"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
/**
 * Higher Order Component for scrolling a wrapped component into view on mount.
 * For it's child, it takes a function with a single ref param that will return
 * a React component that assigns that ref.
 */
const MountScroller = ({ children, alignToTop, delay = 0 }) => {
    // Create the ref to pass to the child
    const childRef = (0, react_1.createRef)();
    // Scroll the child into view only on mount
    (0, react_1.useEffect)(() => {
        const timeout = setTimeout(() => {
            if (childRef.current && childRef.current.scrollIntoView) {
                childRef.current.scrollIntoView(alignToTop);
            }
        }, delay);
        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, children(childRef));
};
MountScroller.propTypes = {
    /**
     * A function that takes in a React.RefObject and returns a component with
     * that ref assigned to it.
     */
    children: prop_types_1.default.func.isRequired,
    /**
     * Whether or not the scrollIntoView call is made with alignToTop set.
     */
    alignToTop: prop_types_1.default.bool,
    /**
     * Delay to add to the scrollIntoView call (ms)
     */
    delay: prop_types_1.default.number
};
exports.default = MountScroller;
//# sourceMappingURL=MountScroller.js.map